import React from 'react';
import { Button, Icon } from '@gerdau/hefesto';
import { InformationPanel } from '@gerdau/hefesto-mais-web/InformationPanel';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { ApplicationState } from '../../../../../store';
import { updateConstructionRegistrationSettings } from '../../../../../store/ducks/contracts-and-constructions/actions';
import {
  IContractsManagerState,
  INITIAL_CONSTRUCTION_REGISTRATION
} from '../../../../../store/ducks/contracts-and-constructions/types';
import { EFabricationContractsStatus } from '../../../../../store/ducks/fabrication-contracts/types';
import { loadFabricationOrders } from '../../../../../store/ducks/fabrication-orders/actions';
import { FABRICATION_ORDER_INITIAL_STATE } from '../../../../../store/ducks/fabrication-purchase-order';
import { updateFabricationPurchaseOrderSettings } from '../../../../../store/ducks/fabrication-purchase-order/actions';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { EOrdersRoutes } from '../../../../Orders/orders.routes';
import { EPurchaseRoutes } from '../../../../Purchase/purchase.routes';
import { EConstructionsRoutes } from '../../../contractsAndConstructions.routes';

interface IViewOptionsButtonProps {
  contractNumber: string;
  contractStatus: EFabricationContractsStatus;
  contractsManager: IContractsManagerState;
}

const ViewOptionsButton: React.FC<IViewOptionsButtonProps> = ({
  contractNumber,
  contractStatus,
  contractsManager
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const codEmr = contractsManager.selectedCustomerId
    ? contractsManager.selectedCustomerId
    : 'not_set';

  const fabricationOrderState = useSelector(
    (appState: ApplicationState) => appState.fabricationOrders
  );

  const goToFabricationOrdersFacelift = () => {
    history.push(`${ERoutes.ORDERS}/${EOrdersRoutes.FABRICATION_ORDERS}`);
    dispatch(
      loadFabricationOrders(
        [contractNumber],
        fabricationOrderState.selectedStartDate,
        fabricationOrderState.selectedEndDate
      )
    );
  };

  const goToPurchaseFabricationFacelift = () => {
    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}`);
    dispatch(
      updateFabricationPurchaseOrderSettings({
        ...FABRICATION_ORDER_INITIAL_STATE,
        constructionIdentification: {
          ...FABRICATION_ORDER_INITIAL_STATE.constructionIdentification,
          contractNumber
        }
      })
    );
  };

  const goToConstructionRegistrationFacelift = () => {
    history.push(
      `${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}${EConstructionsRoutes.CONSTRUCTION_REGISTRATION}`
    );
    dispatch(
      updateConstructionRegistrationSettings({
        ...INITIAL_CONSTRUCTION_REGISTRATION,
        contractNumber
      })
    );
  };

  return (
    <InformationPanel
      title="Opções"
      position={'bottom right'}
      panelOptions={[
        {
          handleOnClick: () => {
            dispatch(
              sendTagging({
                screenName: 'LG:ContratosEObras:SelecaoDoEmissor',
                itemName: 'button: ver_pedidos',
                itemDescription:
                  'contratoEObras_selecaoDoEmissor_menuOpcoes_verPedidos',
                contratoObra: contractNumber,
                filterInfo: `#codEmr:${codEmr}`,
                event: 'click'
              })
            );
            goToFabricationOrdersFacelift();
          },
          text: 'Ver pedidos',
          disabled: contractStatus === EFabricationContractsStatus.NEW_CONTRACT
        },
        {
          handleOnClick: () => {
            dispatch(
              sendTagging({
                screenName: 'LG:ContratosEObras:SelecaoDoEmissor',
                itemName: 'button: novo_pedido',
                itemDescription:
                  'contratoEObras_selecaoDoEmissor_menuOpcoes_novoPedido',
                event: 'click'
              })
            );
            goToPurchaseFabricationFacelift();
          },
          text: 'Novo pedido',
          disabled: contractStatus !== EFabricationContractsStatus.OPEN
        },
        {
          handleOnClick: () => {
            dispatch(
              sendTagging({
                screenName: 'LG:ContratosEObras:SelecaoDoEmissor',
                itemName: 'button: cadastrar_obra',
                itemDescription:
                  'contratoEObras_selecaoDoEmissor_menuOpcoes_cadastrarObra',
                event: 'click'
              })
            );
            goToConstructionRegistrationFacelift();
          },
          text: 'Cadastrar obra',
          disabled: contractStatus !== EFabricationContractsStatus.NEW_CONTRACT
        }
      ]}
      trigger={
        <div>
          <Button
            name="options"
            variant="neutral"
            icon={<Icon option="MoreVertical" />}
          />
        </div>
      }
    />
  );
};

export default ViewOptionsButton;
